import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ANALYTICS_PREFIX } from '../../common/constants.tsx';
import { PageWorkTypesProps } from '../../common/types.tsx';
import { LeftHandSideWrapper } from '../../common/ui/left-hand-side-wrapper/left-hand-side-wrapper.tsx';
import { RightHandSideWrapper } from '../../common/ui/right-hand-side-wrapper/right-hand-side-wrapper.tsx';
import { useWizardConfiguration } from '../../controllers';
import { IssueTypeIconName } from '../assets/issue-type-svgs.tsx';

import { LeftHandSidePageWorkTypes } from './left-hand-side/left-hand-side';
import { RightHandSidePageWorkTypes } from './right-hand-side/right-hand-side';

export const PageWorkTypes: React.FC<PageWorkTypesProps> = ({
	defaultIssueTypes,
	onClickNext,
	projectName,
	selectedIssueTypes,
	onToggleIssueType,
	isIllustrationRefresh,
}) => {
	const issueTypeIcons: IssueTypeIconName[] =
		selectedIssueTypes.length === 0
			? ['Task']
			: selectedIssueTypes.map((issueType) => issueType.icon);

	const { createAnalyticsEvent } = useAnalyticsEvents();
	const {
		teamType,
		projectDetails: { template },
	} = useWizardConfiguration();

	useEffect(() => {
		createAnalyticsEvent({
			action: 'viewed',
			eventType: 'screen',
			name: `${ANALYTICS_PREFIX}WorkTypes`,
			attributes: {
				teamType,
				template,
			},
		}).fire();
	}, [createAnalyticsEvent, teamType, template]);

	return (
		<>
			<LeftHandSideWrapper isIllustrationRefresh={isIllustrationRefresh}>
				<LeftHandSidePageWorkTypes
					selectedIssueTypes={selectedIssueTypes}
					onToggleIssueType={onToggleIssueType}
					defaultIssueTypes={defaultIssueTypes}
					onClickNext={onClickNext}
				/>
			</LeftHandSideWrapper>
			<RightHandSideWrapper>
				<RightHandSidePageWorkTypes
					projectName={projectName}
					issueTypesIcons={issueTypeIcons}
					isIllustrationRefresh={isIllustrationRefresh}
				/>
			</RightHandSideWrapper>
		</>
	);
};
